import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { errorsReducer as errors } from './errors';
import { sessionReducer as session } from './session';
import { devicesReducer as devices } from './devices';
import { eventsReducer as events } from './events';
import { geofencesReducer as geofences } from './geofences';
import { groupsReducer as groups } from './groups';
import { positionsReducer as positions } from "./positions";
import { driversReducer as drivers } from './drivers';
import { maintenancesReducer as maintenances } from './maintenances';
import { calendarsReducer as calendars } from './calendars';
/** MOD */
import { revendasReducer as revendas } from "./revendas";
import { costsReducer as costs } from './costs';
import { usersReducer as users } from "./users";
import throttleMiddleware from './throttleMiddleware';
import { stoppedReducer } from "./stoppedSlice"; // <-- import nomeado

const reducer = combineReducers({
  errors,
  session,
  devices,
  positions,
  events,
  geofences,
  groups,
  drivers,
  maintenances,
  calendars,
  /** MOD */
  revendas,
  costs,
  users,
  stopped: stoppedReducer, // <-- adicionado aqui
});

export { errorsActions } from './errors';
export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from "./positions";
export { eventsActions } from './events';
export { geofencesActions } from './geofences';
export { groupsActions } from './groups';
export { driversActions } from './drivers';
export { maintenancesActions } from './maintenances';
export { calendarsActions } from './calendars';
/** MOD */
export { revendasActions } from "./revendas";
export { costsActions } from './costs';
export { usersActions } from './users';
export { stoppedActions } from './stoppedSlice';

export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(throttleMiddleware),
});